
<template>
  <QuillEditor
    ref="editor"
    :placeholder="placeholder"
    :modules="modules"
    theme="snow"
    toolbar="full"
  />
  <!-- VueQuill provides 3 pre-configured toolbar options essential, minimal, full, and "" to use default options. -->
</template>

<script>
import axios from "axios";
import { QuillEditor } from "@vueup/vue-quill";
import ImageUploader from "quill-image-uploader";

import "@/assets/ql.css";

export default {
  components: {
    QuillEditor,
  },
  props: {
    placeholder: {
      type: String,
      default: "متن خود را در این قسمت بنویسید...",
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      modules: {
        name: "imageUploader",
        module: ImageUploader,
        options: {
          upload: (file) => {
            return new Promise((resolve, reject) => {
              let formData = new FormData();
              formData.append("file", file);
              axios
                .post("/api/file/upload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((res) => {
                  resolve(res.data);
                })
                .catch((error) => {
                  reject("Upload failed");
                })
                .finally(() => {});
            });
          },
        },
      },
    };
  },
  computed: {
    editor() {
      return this.$refs.editor.getQuill();
    },
  },
  mounted() {
    this.editor.format("direction", "rtl");
    this.editor.format('align', 'right');

  },
  methods: {
    getHTML() {
      return this.$refs.editor.getHTML();
    },
    setHTML(value) {
      return this.$refs.editor.setHTML(value);
    },
  },
};
</script>
<style>
.ql-editor {
  direction: rtl;
  text-align: right;
  font-size: initial;
}

.quill-editor img {
  max-width: 100%;
  height: auto;
}

.ql-toolbar.ql-snow .ql-formats {
  margin-right: 0;
  margin-left: 0;
  margin-inline-end: 15px;
}

.ql-snow .ql-tooltip {
  z-index: 99999;
}

.ql-snow .ql-toolbar .ql-formats {
  margin: 8px;
}

.ql-snow .ql-toolbar .ql-formats:first-child {
  margin-inline-start: 12px;
}

.ql-snow .ql-editor pre.ql-syntax {
  direction: ltr;
  text-align: left;
}
</style>